var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-img bg-white"},[_c('img',{staticClass:"img",staticStyle:{"display":"block"},attrs:{"src":_vm.sharePictureUrl}}),_c('transition',{attrs:{"name":"van-fade"}},[(_vm.sharePictureUrl&&_vm.showTips)?_c('div',{staticClass:"text-center save-tips"},[_vm._v("长按保存图片至相册~")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }